/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  GET_VIDEO_DETAILS,
  GET_VIDEO_DETAILS_SUCCESS,
  GET_VIDEO_DETAILS_FAIL,
  BOOKMARK_VIDEO,
  BOOKMARK_VIDEO_SUCCESS,
  BOOKMARK_VIDEO_FAIL,
  RATE_VIDEO,
  RATE_VIDEO_SUCCESS,
  RATE_VIDEO_FAIL,
} from './redux';
import Request from 'app/utils/xhrWrapper';

export function* getVideoDetails() {
  yield takeEvery(GET_VIDEO_DETAILS, function* ({ data: { id } }) : any {
    try {
      const response = yield Request.get(`partner/TV/movie/uid/${id}`);
      const responseData = _.get(response, ['data']);
      let videoDetails = _.get(responseData, 'one');
      let recoms = _.get(responseData, ['recom', 'data']);
      let episodes = _.get(responseData, ['episodeBySeason', 'data']);
      if (responseData) {
        yield put({
          type: GET_VIDEO_DETAILS_SUCCESS, data: {
            videoDetails,
            recoms,
            episodes,
          },
        });
      }
    } catch (error) {
      yield put({ type: GET_VIDEO_DETAILS_FAIL, data: error });
    }
  });
}

export function* bookmarkVideo() {
  yield takeEvery(BOOKMARK_VIDEO, function* ({ data: { id, link } }) : any {
    try {
      const response = yield Request.get(link);
      yield put({ type: GET_VIDEO_DETAILS, data: { id } });
      yield put({ type: BOOKMARK_VIDEO_SUCCESS, data: response.data });
    } catch (error) {
      yield put({ type: BOOKMARK_VIDEO_FAIL, data: error });
    }
  });
}

export function* rateVideo() {
  yield takeEvery(RATE_VIDEO, function* ({ data: { id, rate } }) : any {
    try {
      const response = yield Request.get(`https://api.filimo.com/api/fa/v1/movie/rate/add/uid/${id}/rate/${rate}`);
      yield put({ type: GET_VIDEO_DETAILS, data: { id } });
      yield put({ type: RATE_VIDEO_SUCCESS, data: response.data });
    } catch (error) {
      yield put({ type: RATE_VIDEO_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getVideoDetails),
    fork(bookmarkVideo),
    fork(rateVideo),
  ]);
}
